module.exports = __webpack_public_path__ + "static/media/LRLE07.2d91a8fc.jpg";